export default "__VITE_ASSET__CSV8nxx1__"